document.addEventListener("DOMContentLoaded", () => {

  let resizingLayer = null;
  let startX = 0;
  let startSize = 0;

  document.addEventListener("pointerdown", (e) => {

    const handle = e.target.closest(
      ".text-resize-handle"
    );

    if (!handle) return;

    e.preventDefault();
    e.stopPropagation();

    resizingLayer =
      handle.closest(
        ".embroidery-text-layer"
      );

    startX = e.clientX;

    startSize = parseFloat(
      getComputedStyle(
        resizingLayer
      ).fontSize
    );

  });

  document.addEventListener(
    "pointermove",
    (e) => {

      if (!resizingLayer) return;

      const delta =
        e.clientX - startX;

      let newSize =
        startSize + delta;

      if (newSize < 12)
        newSize = 12;

      resizingLayer.style.fontSize =
  newSize + "px";

resizingLayer
.querySelectorAll(".curve-letter")
.forEach(letter => {

  letter.style.fontSize =
    newSize + "px";

});

      resizingLayer.dataset.fontSize =
        Math.round(newSize);

    }
  );

  document.addEventListener(
    "pointerup",
    () => {

      if (resizingLayer) {

        window.EMBStorage?.save();

        document.dispatchEvent(
          new CustomEvent(
            "embroideryUpdated"
          )
        );

      }

      resizingLayer = null;

    }
  );
let resizingImageLayer = null;
let imageStartX = 0;
let imageStartWidth = 0;

document.addEventListener("pointerdown", (e) => {

  const imageHandle =
    e.target.closest(".resize-handle");

  if (!imageHandle) return;

  e.preventDefault();
  e.stopPropagation();

  resizingImageLayer =
    imageHandle.closest(
      ".embroidery-image-layer"
    );

  imageStartX =
    e.clientX;

  imageStartWidth =
    resizingImageLayer.offsetWidth;

});

document.addEventListener(
  "pointermove",
  (e) => {

    if (!resizingImageLayer)
      return;

    const delta =
      e.clientX -
      imageStartX;

    let newWidth =
      imageStartWidth +
      delta;

    if (newWidth < 50)
      newWidth = 50;

    resizingImageLayer.style.width =
      newWidth + "px";

    document.dispatchEvent(
      new CustomEvent(
        "embroideryUpdated"
      )
    );

  }
);

document.addEventListener(
  "pointerup",
  () => {

    if (
      resizingImageLayer
    ) {

      window.EMBStorage?.save();

      document.dispatchEvent(
        new CustomEvent(
          "embroideryUpdated"
        )
      );

    }

    resizingImageLayer =
      null;

  }
);
});